<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Cambio de Contraseña</h4>
            <p>En esta pantalla usted podra realizar el cambio de Contraseña</p>        
        </div>
    </div>

    <div class="form-group">
        <label for="old_password">Contraseña Actual</label>
        <input type="password" name="old_password" v-model="old_password" class="form-control" :class="error_class.old_password" placeholder="Contraseña Actual">
        <transition name="fade" mode="out-in">
        <small v-if="error.old_password" id="old_password" class="text-danger">{{error.old_password}}</small>
        </transition>
    </div>

    <div class="form-group">
        <label for="new_password">Nueva Contraseña</label>
        <input type="password" name="new_password" v-model="new_password" class="form-control" :class="error_class.new_password" placeholder="Contraseña Actual">
        <transition name="fade" mode="out-in">
        <small v-if="error.new_password" id="old_password" class="text-danger">{{error.new_password}}</small>
        </transition>
    </div>

    <div class="form-group">
        <label for="repeat_password">Repita la nueva Contraseña</label>
        <input type="password" name="repeat_password" v-model="repeat_password" class="form-control" :class="error_class.repeat_password" placeholder="Contraseña Actual">
        <transition name="fade" mode="out-in">
        <small v-if="error.repeat_password" id="old_password" class="text-danger">{{error.repeat_password}}</small>
        </transition>
    </div>
    <div class="form-row">
        <button class="btn btn-outline-primary col-12 col-md-4 offset-md-4" :disabled="status_send" @click="mChangePassword">
            Actualizar <font-awesome-icon icon="save" size="lg" />
        </button>    
    </div>
    <modal-loading :id-modal="mLoading" :title="tLoading" ></modal-loading>
    {{ c_repeat_password }}
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'password-user',
    data(){
        return {
            old_password:null,
            new_password:null,
            repeat_password:null,
            status_send:true,
            error:{
                old_password:null,
                new_password:null,
                repeat_password:null
            },
            error_class:{
                old_password:null,
                new_password:null,
                repeat_password:null
            },
            mLoading:'load-change-password',
            tLoading:'Solicitando'
        }
    },
    methods:{
        async mChangePassword(){
            this.mShow(this.mLoading);         
            // let url=`changePassword`;
            let url=`changePassword?api_token=${Vue.auth.getToken()}`;
            let u={
                n:this.cUserSession.nick,
                tk:Vue.auth.getToken(),
                p:this.old_password,
                np:this.new_password
            }
            let p = await axios.post(url, qs.stringify(u));
            if(p.data[0].error){
                setTimeout(()=>{                    
                    this.mHide(this.mLoading);                    
                    this.error.old_password=p.data[0].msg;
                    this.error_class.old_password='is-invalid'; 
                },2000);              
                
            }else{
                setTimeout(() =>{
                    this.mHide(this.mLoading);                    
                    this.error.old_password=null;
                    this.error_class.old_password=null;
                    // this.error_class.new_password=null;
                    // this.error_class.repeat_password=null;
                    this.old_password=null,
                    this.new_password=null,
                    this.repeat_password=null;
                    toastr.success(''+p.data[0].msg+'', 'Correcto')
                })                
            }            
        },
        mShow(e){
            $('#'+e).modal('show');
        },
        mHide(e){
            $('#'+e).modal('hide');
        }
    },
    computed:{
        c_repeat_password(){
            
            if( (this.new_password === this.repeat_password) && (this.repeat_password!==null) ){
                this.error.new_password=null;
                this.error.repeat_password=null;
                this.error_class.new_password='is-valid';
                this.error_class.repeat_password='is-valid';
                this.status_send=false;
            }else if(this.repeat_password === null){
                this.error.new_password=null;
                this.error.repeat_password=null;
                this.error_class.new_password=null;
                this.error_class.repeat_password=null;
                this.status_send=true;
            }
            else{
                this.error.new_password='Las contraseñas no coinciden';
                this.error.repeat_password='Las contraseñas no coinciden';
                this.error_class.new_password='is-invalid';
                this.error_class.repeat_password='is-invalid';
                this.status_send=true;
            }           
        },
        cUserSession(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/PasswordUser.vue